import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  Chip,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  LinearProgress,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Typography,
  CircularProgress
} from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import SchoolIcon from '@mui/icons-material/School';
import LogoutIcon from '@mui/icons-material/Logout';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import QuizIcon from '@mui/icons-material/Quiz';
import elearningAuthService from '../services/elearningAuth.service';
import elearningService from '../services/elearning.service';

const PDF_LISTS = {
  'general': [
    'G_1_Action Plan. Protection of public spaces COM(2017) 612.pdf',
    'G_2_Council conclusions on future priorities for strengthening the joint counterterrorism efforts of the European Union and its Member States 16820.2024.pdf',
    'G_3_Council Conclusions on the Protection of Public Spaces 9545.21.pdf',
    'G_4_Counter Terrorism Agenda COM(2020) 795.pdf',
    'G_5_Directive 2022_2557.pdf',
    'G_6_Directive 2017_541.pdf',
    'G_7_EU CITIES AGAINST RADICALISATION 2019.pdf',
    'G_8_EU Quick Guide to support protection of Places of Worship_2021.pdf',
    'G_9_EU Security Union Strategy COM(2020) 605.pdf',
    'G_10_EU Strategy on Combating Antisemitism COM(2021) 615.pdf',
    'G_11_European Council meeting conclusions_2020.pdf',
    'G_12_European Internal Security Strategy COM(2025) 148.pdf',
    'G_13_Europol_European Terrorism Situation and Trend Report 2022.pdf',
    'G_14_Europol_Terrorism Situtation and Trend Report 2024.pdf',
    'G_15_Europol Terrorism situtation and Trend report 2025.pdf',
    'G_16_Generic vehicle models for finite element numerixal simulations.pdf',
    'G_17_Good practices. Protection of public spaces SWD(2019).pdf',
    'G_18_Homeland Security 2019._Strategic Framework for Countering Terrorism and Targeted Violence.pdf',
    'G_19_Joint Statement by the EU Home Affairs Ministers on the recent terrorist attacks in Europe.pdf',
    'G_20_JRC Technical Report_Key information on the protection of Public Spaces.pdf',
    'G_21_NPSA_Recognising Terrorist Threats.pdf',
    'G_22_Press Release. Security Union A Counter Terrorism Agenda 2020.pdf',
    'G_23_Protecting Crowded Places- Design and Technical Issues_UK_20212.pdf',
    'G_24_Review on Soft target protection guidance v2.pdf',
    'G_25_Security by Design_CBRN.pdf',
    'G_26_Vehicle SPEed Evaluation and Dynamics Assessment (V-SPEED) - factsheet.pdf',
    'G_27_Review on Vehicle barrier protection guidance.pdf',
    'G_28_Persistent Threat of Terrorist Ambush Attacks.pdf',
    'G_29_CST security procedures for places of worship.1552646163.pdf',
    'G_30_DesignTechnicalIssues2014.pdf',
    'G_31_Fact Sheet on EU Protective Security Advisors.pdf',
    'G_32_FEMA Handbook for Rapid Visual Screening of Buildings to Evaluate Terrorism Risks.pdf',
    'G_33_A How To Guide to Mitigate Potential Terrorist Attacks Against Buildings.pdf',
    'G_34_Emerging_Technologies_May_Heighten_Terrorist_Threats.pdf',
    'G_35_Integrated Security Guide.pdf',
    'G_36_NaCTSO_Guidance_Note_1_-_2015_-_Dynamic_Lockdown_v1_0.pdf',
    'G_37_Counter Terrorism Protective Security Advice for Places of Worship.pdf',
    'G_38_Plan-of-Action-to-Safeguard-Religious-Sites-11092019.pdf',
    'G_39_Protecting against Terrorism_MI5.pdf',
    'G_40_Mass Attacks in Public spaces 2019.pdf',
    'G_41_Mass Attacks in Public spaces 2018.pdf',
    'G_42_Mass Attacks in Public spaces 2016-2020.pdf',
    'G_43_Mitigating Attacks on Houses of Worship Security Guide_508.pdf',
    'G_44_Run Hide Tell.pdf',
    'G_45_The Security by Design Concept.pdf',
    'G_49_Executive summary of the study into measures.pdf'
  ],
  'cbrn-public-spaces': [
    'CBRNE_11_Interpol_Public messages to use in the immediate response to a CBRN attack.pdf',
    'CBRN_1_NATO_Guidelines for First Responders to a CBRN Incident.pdf',
    'CBRN_2_ICRC_Chemical, Biological, Radiological and Nuclear Response.pdf',
    'CBRN_3_NIOSH_Chemical, Biological, Radiological and Nuclear Respiratory Protection Handbook.pdf',
    'CBRN_4_DG Home_Protection of public spaces CBRN & CER.pdf',
    'CBRN_5_ΙΑΕΑ_Communication with the Public in a Nuclear or Radiological Emergency.pdf',
    'CBRN_6_IAEA_Method for Developing a Communication Strategy and Plan for a Nuclear or Radiological Emergency.pdf',
    'CBRN_7_ UNICRI_Toolkit on effective CBRN planning and response for policymakers and CBRN makers.pdf',
    'CBRN_8_Australia_Domestic Health Response Plan for Chemical, Biological, Radiological or Nuclear Incidents of National Significance.pdf',
    'CBRN_9_Prospheres_Introduction to CBRN Threats.pdf',
    'CBRN_10_UNODC_Chemical, Biological, Radiological and Nuclear (CBRN) in VBSS Training.pdf',
    'CBRN_12_Improvised Explosive Device (IED) Guidelines for Places of Mass Gathering.pdf',
    'CBRN_13_Potential misuse as an alternative source of Hydrogen Peroxide.pdf',
    'CBRN_14_Remove campaign.pdf'
  ],
  'uav-counter-mitigation': [
    'UAV_1_Drone Strategy 2.0.pdf',
    'UAV_2_UK Counter - Unmanned Aircraft Strategy.pdf',
    'UAV_3_JAPCC_A Comprehensive Approach to Countering Unmanned Aircraft Systems.pdf',
    'UAV_4_Protection against Unmanned Aircraft Systems.pdf',
    'UAV_5_Protection against Unmanned Aircraft Systems.pdf',
    'UAV_6_CUAS_Countering Threats from Uncrewed Aerial Systems - Making your site ready.pdf',
    'UAV_7_CUAS_A senior executives guide to making your site ready.pdf',
    'UAV_8_CUAS_A Guide to Selecting C-UAS Technology.pdf',
    'UAV_9_CUAS_Developing Operational Requirements for C-UAS Detect, Track and Identify Technology.pdf',
    'UAV_10_CUAS_Assessing the Threat and Vulnerability.pdf',
    'UAV_11_CUAS_Notified Airspace as part of a C-UAS Strategy.pdf',
    'UAV_12_Countering threats from Uncrewewed Aerial Systems (C-UAS).pdf',
    'UAV_13_Protecting Against the Threat of UAS.pdf',
    'UAV_14_Framework for Responding to a drone incident.pdf',
    'UAV_15_Interpol Drone Countermeasure Exercise Report.pdf',
    'UAV_16_EASA_Drone Incident Management at Aerodromes.pdf',
    'UAV_17_CISA_Unauthorized Drone Activity Over Sporting Venues.pdf',
    'UAV_18_CISA_ChemLock_Drone Activity.pdf',
    'UAV_19_CISA_Recognize suspicious UAS.pdf',
    'UAV_20_Berlin Memorandum on Good Practices for Countering Terrorist Use of Unmanned Aerial Systems.pdf',
    'UAV_21_Regulation (EU) 2019_947 (UAS).pdf',
    'UAV_22_Countering potential threats posed by drones COM (2023) 659.pdf',
    'UAV_23_REGULATION (EU) 2019_945 (UAS).pdf'
  ],
  'security-manager': [
    'SM_1_HM Government_Functional Standard.pdf',
    'SM_2_Australian Government Protective Security Policy Framework.pdf',
    'SM_3_CISA_The Risk Management Process.pdf',
    'SM_4_Best Practices for Planning and Managing Physical Security.pdf',
    'SM_5_CISA_Security Planning Workbook.pdf',
    'SM_6_CISA_Venue Guide for Security Enhancements.pdf',
    'SM_7_Rail high Speed network security handbook.pdf',
    'SM_8_Crowded places guidance_UK_NaCTSO.pdf',
    'SM_9_Security Manual Perimeter.pdf',
    'SM_10_Protecting Buildings against terrorism.pdf',
    'SM_11_Reporting Suspicious Activity – Critical for Terrorism Prevention.pdf',
    'SM_12_Review on Soft Target-Public Space Protection guidance.pdf',
    'SM_13_Threat Levels Advice for security managers.pdf'
  ],
  'tourism-security-awareness': [
    'SA_1_NPSA_High Street Hospitality.pdf',
    'SA_2_NPSA_Mitigation of Terrorist Threats at Venues.pdf',
    'SA_3_FBI_Active Shooter event.pdf',
    'SA_4_ISAC.pdf',
    'SA_5_White paper_Security and Safety in the Tourism Sector.pdf',
    'SA_6_Event Safety Guide_Sweden.pdf',
    'SA_7_ANZCTC_Active_shooter_guidelines_for_places_of_mass_gathering_-_2015_Update.pdf',
    'SA_8_Safety & Democracy - Secucities Cities against terrorism.pdf'
  ],
  'insider-threat': [
    'IT_1_CISA_Insider Threat Mitigation Guide.pdf',
    'IT_2_NCSC_Managing Insider Threats.pdf',
    'IT_3_Enhancing Canada\'s Critical Infrastructure Resilience to Insider Riskpdf.pdf',
    'IT_4_Australia_Countering The Insider Threat.pdf',
    'IT_5_Managing insider threat EY.pdf',
    'IT_6_NITTF_Insider Threat Guide 2017.pdf',
    'IT_7_NPSA_Countering the Threat of Sabotage Operations.pdf',
    'IT_8_Insider Threat Detection Study_CCDCOE.pdf',
    'IT_9_Insider Threat Awareness Training Resource Guide.pdf',
    'IT_10_Protect your Organization from the Inside Out Government Best Practices.pdf'
  ],
  'response-recovery': [
    'RR_1_CISA_Crisis event response and recovery access framework.pdf',
    'RR_2_FEMA Managing the Emergency Consequences of Terrorist Incidents 2002.pdf',
    'RR_3_RAN_ Centre of Excellence. Enhancing_resilience_victims_after_terrorist_attacks_032018_en.pdf',
    'RR_4_National Response Framework.pdf',
    'RR_5_National Disaster Recovery Framework.pdf',
    'RR_6_UK_The UK Government Resilience Framework.pdf',
    'RR_7_Canada_An Emergency Management Framework for Canadapdf.pdf',
    'RR_8_EU Civil Protection Mechanism.pdf',
    'RR_9_IFRC Civil Protection Guidance for National Societies and Federation Secretariat Relations with European Union Actors.pdf',
    'RR_10_Preventing and managing disaster risk in Europe.pdf',
    'RR_11_SOP Crisis Response Recovery UNDP.pdf',
    'RR_12_UK Recovery emergency Management Guide.pdf',
    'RR_13_Developing a comprehensive incident management response plan-FINAL.pdf',
    'RR_14_Recommendations for National Risk Assessment for Disaster Risk Management.pdf'
  ]
};

const COURSES = [
  { key: 'general', name: 'General', publicFolder: 'ceZaeEuxHePTvCP/General' },
  { key: 'cbrn-public-spaces', name: 'CBRN in Public Spaces', publicFolder: 'ceZaeEuxHePTvCP/1. CBRN in Public Spaces' },
  { key: 'uav-counter-mitigation', name: 'Non cooperative UAV counter mitigation', publicFolder: 'ceZaeEuxHePTvCP/2. Non cooperative UAV counter_mitigation' },
  { key: 'security-manager', name: 'Security Manager', publicFolder: 'ceZaeEuxHePTvCP/3. Security Manager' },
  { key: 'tourism-security-awareness', name: 'Security Awareness for Tourism Industry employees', publicFolder: 'ceZaeEuxHePTvCP/4. Security Awareness for Tourism Industry employees' },
  { key: 'insider-threat', name: 'Insider Threat', publicFolder: 'ceZaeEuxHePTvCP/5. Insider Threat' },
  { key: 'response-recovery', name: 'Response and Recovery on Crisis Situations', publicFolder: 'ceZaeEuxHePTvCP/6. Response and Recovery on Crisis Situations' }
];

const FINAL_QUIZ_KEY = 'final-quiz';

const normalizeQuizOptions = (options) => {
  if (Array.isArray(options)) {
    return options;
  }

  if (typeof options === 'string') {
    try {
      const parsed = JSON.parse(options);
      return Array.isArray(parsed) ? parsed : [];
    } catch (_error) {
      return [];
    }
  }

  if (options && typeof options === 'object') {
    return Object.keys(options)
      .sort()
      .map((key) => options[key])
      .filter((value) => typeof value === 'string' && value.length > 0);
  }

  return [];
};

const normalizeQuizPayload = (payload) => ({
  categories: (payload.categories || []).map((category) => ({
    ...category,
    questions: (category.questions || []).map((question) => ({
      ...question,
      options: normalizeQuizOptions(question.options)
    }))
  })),
  passPercentage: payload.passPercentage || 70,
  totalQuestions: payload.totalQuestions || 0
});

const ElearningCourses = () => {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);
  const [completions, setCompletions] = useState({});
  const [quizData, setQuizData] = useState({ categories: [], passPercentage: 70, totalQuestions: 0 });
  const [quizAnswers, setQuizAnswers] = useState({});
  const [quizSubmitting, setQuizSubmitting] = useState(false);
  const [quizResult, setQuizResult] = useState(null);
  const [activeView, setActiveView] = useState('course');
  const [loading, setLoading] = useState(true);
  const [selectedCourse, setSelectedCourse] = useState(COURSES[0].key);
  const [selectedPdf, setSelectedPdf] = useState(null);

  // Initialize user
  useEffect(() => {
    const user = elearningAuthService.getCurrentUser();
    if (!user || !user.token) {
      navigate('/elearning');
    } else {
      setCurrentUser(user);
    }
  }, [navigate]);

  // Fetch completions
  useEffect(() => {
    if (!currentUser) return;

    const fetchData = async () => {
      try {
        setLoading(true);
        const [completionResponse, quizResponse] = await Promise.all([
          elearningService.getCompletions(),
          elearningService.getQuiz()
        ]);
        const completionMap = {};
        const completionsList = Array.isArray(completionResponse)
          ? completionResponse
          : completionResponse?.data || [];
        completionsList.forEach(completion => {
          completionMap[completion.courseKey] = completion;
        });
        setCompletions(completionMap);

        const quizPayload = quizResponse?.data || quizResponse || {};
        setQuizData(normalizeQuizPayload(quizPayload));

        if (completionMap[FINAL_QUIZ_KEY]) {
          setQuizResult({
            score: completionMap[FINAL_QUIZ_KEY].score,
            passed: completionMap[FINAL_QUIZ_KEY].passed,
            successful: completionMap[FINAL_QUIZ_KEY].passed
          });
        }
      } catch (error) {
        console.error('Error fetching e-learning data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [currentUser]);

  // Set initial PDF when course changes
  useEffect(() => {
    const pdfs = PDF_LISTS[selectedCourse] || [];
    if (pdfs.length > 0) {
      setSelectedPdf(pdfs[0]);
    }
  }, [selectedCourse]);

  const handleLogout = () => {
    elearningAuthService.logout();
    navigate('/elearning');
  };

  const handleSelectCourse = (courseKey) => {
    setSelectedCourse(courseKey);
    setActiveView('course');
  };

  const handleMarkComplete = async () => {
    try {
      await elearningService.saveCompletion({
        courseKey: selectedCourse,
        score: 100,
        passed: true
      });
      
      setCompletions(prev => ({
        ...prev,
        [selectedCourse]: {
          ...prev[selectedCourse],
          passed: true,
          completedAt: new Date().toISOString()
        }
      }));
    } catch (error) {
      console.error('Error marking course complete:', error);
    }
  };

  const handleQuizAnswerChange = (questionId, value) => {
    setQuizAnswers(prev => ({
      ...prev,
      [questionId]: Number(value)
    }));
  };

  const handleQuizSubmit = async () => {
    try {
      setQuizSubmitting(true);
      const response = await elearningService.submitQuiz(quizAnswers);
      const payload = response?.data || response;

      setQuizResult(payload);
      setCompletions(prev => ({
        ...prev,
        [FINAL_QUIZ_KEY]: payload.completion || {
          courseKey: FINAL_QUIZ_KEY,
          score: payload.score,
          passed: payload.passed,
          completedAt: new Date().toISOString()
        }
      }));
    } catch (error) {
      console.error('Error submitting quiz:', error);
      setQuizResult({
        passed: false,
        message: error.response?.data?.message || 'Quiz submission failed.'
      });
    } finally {
      setQuizSubmitting(false);
    }
  };

  const currentCourseData = COURSES.find(c => c.key === selectedCourse);
  const pdfs = PDF_LISTS[selectedCourse] || [];
  const isCompleted = completions[selectedCourse]?.passed;
  const completedCourseCount = COURSES.filter(course => completions[course.key]?.passed).length;
  const allCoursesCompleted = completedCourseCount === COURSES.length;
  const finalQuizCompletion = completions[FINAL_QUIZ_KEY];
  const isSuccessful = Boolean(finalQuizCompletion?.passed);
  const answeredQuestions = Object.keys(quizAnswers).length;
  const currentPdfUrl = selectedPdf ? `/${currentCourseData.publicFolder}/${encodeURIComponent(selectedPdf)}` : null;

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      {/* Header */}
      <Box sx={{ bgcolor: 'white', p: 2, boxShadow: 1, mb: 2 }}>
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <SchoolIcon sx={{ fontSize: 35, color: '#0651A0' }} />
              <Box>
                <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#0651A0' }}>
                  Learning Hub
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {currentUser?.username} • {completedCourseCount}/{COURSES.length} categories completed
                </Typography>
              </Box>
            </Box>
            <Button 
              variant="outlined" 
              color="error" 
              startIcon={<LogoutIcon />}
              onClick={handleLogout}
            >
              Logout
            </Button>
          </Box>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: 3, display: 'flex', flexDirection: 'column', minHeight: 'calc(100vh - 90px)' }}>
        <Paper sx={{ mb: 3, p: 2.5, borderRadius: 2, border: '1px solid #d9e2ec' }}>
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} justifyContent="space-between" alignItems={{ xs: 'flex-start', md: 'center' }}>
            <Box sx={{ flex: 1 }}>
              <Typography variant="h6" sx={{ color: '#0b2545', fontWeight: 700, mb: 0.5 }}>
                Final certification flow
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                Complete every category first. The final quiz is unlocked only after all seven learning sections are marked as completed.
              </Typography>
              <LinearProgress
                variant="determinate"
                value={(completedCourseCount / COURSES.length) * 100}
                sx={{ height: 10, borderRadius: 999, bgcolor: '#e8edf3', '& .MuiLinearProgress-bar': { bgcolor: '#0651A0' } }}
              />
            </Box>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ xs: 'stretch', sm: 'center' }}>
              <Chip
                color={isSuccessful ? 'success' : allCoursesCompleted ? 'primary' : 'default'}
                label={isSuccessful ? 'Successful' : allCoursesCompleted ? 'Quiz unlocked' : 'Quiz locked'}
              />
              <Button
                variant={activeView === 'quiz' ? 'contained' : 'outlined'}
                startIcon={<QuizIcon />}
                onClick={() => setActiveView('quiz')}
                disabled={!allCoursesCompleted}
                sx={{ minWidth: 170 }}
              >
                Final Quiz
              </Button>
            </Stack>
          </Stack>
        </Paper>

        {/* Courses Navigation Bar */}
        <Paper sx={{ mb: 3, bgcolor: '#0651A0', flexShrink: 0 }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', p: 1, gap: 1 }}>
            {COURSES.map(course => {
              const completed = completions[course.key]?.passed;
              return (
                <Button
                  key={course.key}
                  onClick={() => handleSelectCourse(course.key)}
                  sx={{
                    color: selectedCourse === course.key ? '#0651A0' : 'white',
                    bgcolor: selectedCourse === course.key ? 'white' : 'transparent',
                    whiteSpace: 'nowrap',
                    fontWeight: selectedCourse === course.key ? 'bold' : 'normal',
                    flex: '0 0 auto',
                    px: 2,
                    py: 1,
                    borderRadius: 1,
                    '&:hover': {
                      bgcolor: selectedCourse === course.key ? 'white' : 'rgba(255,255,255,0.2)'
                    },
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center'
                  }}
                >
                  {completed && <CheckCircleIcon sx={{ fontSize: 18, color: '#4caf50' }} />}
                  <Typography variant="body2" sx={{ fontWeight: 'inherit' }}>
                    {course.name}
                  </Typography>
                </Button>
              );
            })}
          </Box>
        </Paper>

        {activeView === 'quiz' ? (
          <Paper sx={{ p: { xs: 2, md: 4 }, borderRadius: 2 }}>
            <Stack spacing={3}>
              <Box>
                <Typography variant="h4" sx={{ fontWeight: 700, color: '#0b2545', mb: 1 }}>
                  Final Quiz
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  Answer all questions below. Passing score: {quizData.passPercentage}%.
                </Typography>
              </Box>

              {!allCoursesCompleted && (
                <Alert severity="warning">
                  Finish all learning categories before starting the quiz.
                </Alert>
              )}

              {quizResult?.message && !quizResult?.successful && (
                <Alert severity="error">{quizResult.message}</Alert>
              )}

              {typeof quizResult?.score === 'number' && (
                <Alert severity={quizResult.passed ? 'success' : 'info'}>
                  Score: {quizResult.score}% {quizResult.passed ? '• Your profile is marked as successful.' : '• Review the material and try again.'}
                </Alert>
              )}

              <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
                <Chip label={`${quizData.totalQuestions} questions`} variant="outlined" />
                <Chip label={`${answeredQuestions} answered`} variant="outlined" />
              </Box>

              {quizData.categories.map((category, categoryIndex) => (
                <Paper key={category.key} variant="outlined" sx={{ p: { xs: 2, md: 3 }, borderRadius: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#0651A0', mb: 2 }}>
                    {categoryIndex + 1}. {category.title}
                  </Typography>
                  <Stack spacing={2.5}>
                    {category.questions.map((question, questionIndex) => (
                      <Box key={question.id}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                          {questionIndex + 1}. {question.prompt}
                        </Typography>
                        <FormControl fullWidth>
                          <RadioGroup
                            value={quizAnswers[question.id] ?? ''}
                            onChange={(event) => handleQuizAnswerChange(question.id, event.target.value)}
                          >
                            {question.options.map((option, optionIndex) => (
                              <FormControlLabel
                                key={`${question.id}-${optionIndex}`}
                                value={optionIndex}
                                control={<Radio />}
                                label={option}
                              />
                            ))}
                          </RadioGroup>
                        </FormControl>
                        {questionIndex < category.questions.length - 1 && <Divider sx={{ mt: 2 }} />}
                      </Box>
                    ))}
                  </Stack>
                </Paper>
              ))}

              <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
                <Button variant="text" onClick={() => setActiveView('course')}>
                  Back to materials
                </Button>
                <Button
                  variant="contained"
                  onClick={handleQuizSubmit}
                  disabled={!allCoursesCompleted || quizSubmitting || answeredQuestions !== quizData.totalQuestions}
                  sx={{ bgcolor: '#0651A0', '&:hover': { bgcolor: '#053d7a' } }}
                >
                  {quizSubmitting ? 'Submitting...' : isSuccessful ? 'Retake Quiz' : 'Submit Quiz'}
                </Button>
              </Box>
            </Stack>
          </Paper>
        ) : (
        <Grid container spacing={2} sx={{ flex: 1, minHeight: 600, display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
          {/* Left - PDF List */}
          <Grid item xs={12} md={3} sx={{ display: 'flex', flexDirection: 'column', height: 'auto', minHeight: { xs: 'auto', md: '100%' } }}>
            <Paper sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <Box sx={{ p: 2, bgcolor: '#0651A0', color: 'white', flexShrink: 0 }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  📚 Course Materials
                </Typography>
                <Typography variant="caption" sx={{ opacity: 0.9 }}>
                  {pdfs.length} resources available
                </Typography>
              </Box>
              
              <List sx={{ maxHeight: '80vh', overflow: 'auto', p: 0 }}>
                {pdfs.map((pdf, index) => (
                  <ListItemButton
                    key={index}
                    selected={selectedPdf === pdf}
                    onClick={() => setSelectedPdf(pdf)}
                    sx={{
                      bgcolor: selectedPdf === pdf ? '#e3f2fd' : 'transparent',
                      borderLeft: selectedPdf === pdf ? '4px solid #0651A0' : 'none',
                      pl: selectedPdf === pdf ? 1.5 : 2,
                      py: 1.5,
                      '&:hover': {
                        bgcolor: selectedPdf === pdf ? '#e3f2fd' : '#f5f5f5'
                      }
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 32 }}>
                      <PictureAsPdfIcon sx={{ color: '#d32f2f', fontSize: 20 }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary={pdf.replace('.pdf', '')}
                      primaryTypographyProps={{ 
                        variant: 'body2',
                        sx: { 
                          fontWeight: selectedPdf === pdf ? 600 : 400,
                          wordBreak: 'break-word',
                          whiteSpace: 'normal',
                          lineHeight: 1.3
                        }
                      }}
                    />
                  </ListItemButton>
                ))}
              </List>
            </Paper>
          </Grid>

          {/* Right - PDF Viewer */}
          <Grid item xs={12} md={9} sx={{ display: 'flex', flexDirection: 'column', height: 'auto', minHeight: { xs: 'auto', md: '100%' } }}>
            <Paper sx={{ height: '100%', display: 'flex', flexDirection: 'column', bgcolor: 'white' }}>
              {selectedPdf ? (
                <>
                  <Box sx={{ p: 2.5, bgcolor: '#f5f5f5', borderBottom: '2px solid #e0e0e0', flexShrink: 0 }}>
                    <Typography variant="caption" sx={{ color: '#0651A0', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      {currentCourseData?.name}
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333', mt: 0.5 }}>
                      {selectedPdf.replace('.pdf', '')}
                    </Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mt: 2 }}>
                      <Button
                        variant={isCompleted ? 'outlined' : 'contained'}
                        startIcon={isCompleted ? <CheckCircleIcon /> : <SchoolIcon />}
                        onClick={handleMarkComplete}
                        sx={isCompleted ? {} : { bgcolor: '#0651A0', '&:hover': { bgcolor: '#053d7a' } }}
                      >
                        {isCompleted ? 'Completed' : 'Mark Category Completed'}
                      </Button>
                      {allCoursesCompleted && (
                        <Button variant="outlined" startIcon={<QuizIcon />} onClick={() => setActiveView('quiz')}>
                          Open Final Quiz
                        </Button>
                      )}
                    </Stack>
                  </Box>
                  
                  <Box sx={{ maxHeight: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: '#fafafa', width: '100%' }}>
                    <iframe
                      src={`${currentPdfUrl}#view=fit&toolbar=1`}
                      style={{
                        width: '100%',
                        height: '80vh',
                        border: 'none'
                      }}
                      title="PDF Viewer"
                      allowFullScreen
                    />
                  </Box>
                </>
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column', gap: 2 }}>
                  <Typography color="text.secondary" variant="h6">
                    📄 No Material Selected
                  </Typography>
                  <Typography color="text.secondary" variant="body2">
                    Choose a course above and select a material from the left
                  </Typography>
                </Box>
              )}
            </Paper>
          </Grid>
        </Grid>
        )}
      </Container>

      {/* Bottom Spacing */}
      <Box sx={{ height: 100 }} />

    </Box>
  );
};

export default ElearningCourses;
